// NOTE: hooks
import React, { lazy, Suspense } from 'react'
import { Navigate } from 'react-router-dom'
// NOTE: components
import Layout from '../components/ui/Layout'
import Loading from '../components/ui/Loading'
import SubPage from '../components/ui/SubPage'
// NOTE: main pages
const Home = lazy(() => import('./home/Home'))
const Onboarding = lazy(() => import('./onboarding/Onboarding'))
const Clinic = lazy(() => import('./clinic/Clinic'))
// NOTE: health page
const Goals = lazy(() => import('./goals/Goals'))
const Calendar = lazy(() => import('./calendar/Calendar'))
const Analytics = lazy(() => import('./analytics/Analytics'))
const LifeStyleTools = lazy(() => import('./lifestyleTools/LifeStyleTools'))
const Lifestyle = lazy(() => import('./lifestyleTools/lifestyle/Lifestyle'))
const Forms = lazy(() => import('./forms/Form'))
const Consultations = lazy(() => import('./consultations/Consultations'))
const Documents = lazy(() => import('./documents/Documents'))
const ContentItem = lazy(() => import('./contentItem/ContentItem'))
const Tdee = lazy(() => import('./lifestyleTools/tdee/Tdee'))
const WaterNeed = lazy(() => import('./lifestyleTools/water/WaterNeed'))
const Breathing = lazy(() => import('./lifestyleTools/breathing/Breathing'))
const Life = lazy(() => import('./lifestyleTools/life/Life'))
const Vitals = lazy(() => import('./lifestyleTools/vitals/Vitals'))
// NOTE: forms page
const CustomFormPage = lazy(() => import('../components/customForm/CustomFormPage'))
const CustomFormResultePage = lazy(
	() => import('../components/customForm/customFormResult/CustomFormResultPage')
)
// NOTE: account
const Profile = lazy(() => import('./profile/Profile'))
const Preferences = lazy(() => import('./preferences/Preferences'))
const Setup = lazy(() => import('./setup/Setup'))
const Contact = lazy(() => import('./contact/Contact'))

const accountLinks = [
	{
		to: 'profile',
		text: 'Profile'
	},
	{
		to: 'contact',
		text: 'Contact'
	},
	{
		to: 'preferences',
		text: 'Preferences'
	},
	{
		to: 'setup',
		text: 'Setup'
	}
]

const planLinks = [
	{
		to: 'analytics',
		text: 'Analytics'
	},
	{
		to: 'goals',
		text: 'Goals'
	},
	{
		to: 'lifestyle',
		text: 'Lifestyle'
	},
	{
		to: 'forms',
		text: 'Forms'
	},
	{
		to: 'consultations',
		text: 'Consultations'
	},
	{
		to: 'documents',
		text: 'Documents'
	}
]

const LoadPage = ({ page }: any) => {
	return <Suspense fallback={<Loading />}>{page}</Suspense>
}

const dashboardRoutes = [
	{
		path: '/',
		element: <Layout />,
		children: [
			{
				index: true,
				element: <LoadPage page={<Home />} />
			},
			{
				path: 'health',
				element: <SubPage title="Health" links={planLinks} />,
				children: [
					{
						index: true,
						element: <Navigate to="analytics" />
					},
					{
						path: 'analytics',
						element: <LoadPage page={<Analytics />} />
					},
					{
						path: 'documents',
						element: <LoadPage page={<Documents />} />
					},
					{
						path: 'goals',
						element: <LoadPage page={<Goals />} />
					},
					{
						path: 'lifestyle',
						element: <LoadPage page={<LifeStyleTools />} />
					},
					{
						path: 'forms',
						element: <LoadPage page={<Forms />} />
					},
					{
						path: 'consultations',
						element: <LoadPage page={<Consultations />} />
					}
				]
			},
			{
				path: 'contents/:contentId',
				element: <LoadPage page={<ContentItem />} />
			},
			{
				path: 'calendar',
				element: <LoadPage page={<Calendar />} />
			},
			{
				path: 'clinic',
				children: [
					{
						index: true,
						element: <LoadPage page={<Clinic />} />
					},
					{
						path: 'form/:id',
						element: <LoadPage page={<CustomFormPage />} />
					},
					{
						path: 'form/:id/result',
						element: <LoadPage page={<CustomFormResultePage />} />
					}
				]
			},
			{
				path: 'account',
				element: <SubPage title="Account" links={accountLinks} />,
				children: [
					{
						index: true,
						element: <Navigate to="profile" />
					},
					{
						path: 'profile',
						element: <LoadPage page={<Profile />} />
					},
					{
						path: 'contact',
						element: <LoadPage page={<Contact />} />
					},
					{
						path: 'preferences',
						element: <LoadPage page={<Preferences />} />
					},
					{
						path: 'setup',
						element: <LoadPage page={<Setup />} />
					}
				]
			},
			{
				path: 'health/lifestyle/energy',
				element: <LoadPage page={<Tdee />} />
			},
			{
				path: 'health/lifestyle/water',
				element: <LoadPage page={<WaterNeed />} />
			},
			{
				path: 'health/lifestyle/breathing',
				element: <LoadPage page={<Breathing />} />
			},
			{
				path: 'health/lifestyle/life',
				element: <LoadPage page={<Life />} />
			},
			{
				path: 'health/lifestyle/lifestyle',
				element: <LoadPage page={<Lifestyle />} />
			},
			{
				path: 'health/lifestyle/vitals',
				element: <LoadPage page={<Vitals />} />
			}
		]
	},
	{
		// TODO: fix this as it's rendered without checking if user is authenticated - leave as it is for now and fix when implementing auth.js
		path: '/onboarding',
		element: <LoadPage page={<Onboarding />} />
	}
]

export default dashboardRoutes
